<div class="container-fluid">
  <mat-card style="margin-top: 38px;" [class.mat-elevation-z10]="true">
    <h2>Complete your account</h2>

    <form [formGroup]="accountForm" *ngIf="accountForm">
      <mat-form-field appearance="outline" style="width: 300px; max-width:100%">
        <mat-label>User Name</mat-label>
        <input
          matInput
          id="displayName"
          name="displayName"
          formControlName="displayName"
          placeholder="Enter user name"
          type="email"
          required
        />
        <mat-error
          *ngIf="
            accountForm.get('displayName').touched &&
            accountForm.get('displayName').errors
          "
        >
          Display Name is required
        </mat-error>
      </mat-form-field>

      <div>
        <small>
          We sent you an email with a code to validate that you are the owner of
          the email account. 
          <br />Please enter that code below.
        </small>
      </div>

      <mat-form-field appearance="outline" style="width: 300px; max-width:100%">
        <mat-label>Confirmation Email Code</mat-label>
        <input
          matInput
          id="emailCode"
          formControlName="emailCode"
          placeholder="Enter confirmation email code"
          type="text"
          autocomplete="off"
          required
          trim="blur"
        />
        <mat-error
          *ngIf="
            accountForm.get('emailCode').touched &&
            accountForm.get('emailCode').errors
          "
        >
          Email Code is required
        </mat-error>
        <mat-hint>
          <div style="color: red;" *ngIf="emailSendError">
            There was an error in sending the verification email. Please try
            again.
          </div>
          <span *ngIf="!delayInterval"
            >If you did not get a code, please
            <a
              [attr.href]="requestCounter > 2 || requesting ? null : '#'"
              (click)="
                requestCounter <= 2 && !requesting && requestNewCode($event)
              "
              >Request New Code</a
            >.
          </span>
          <span *ngIf="delayInterval"
            >There have been too many requests to verify this email address.
            Please wait a while, then try again.</span
          >
        </mat-hint>
      </mat-form-field>
      <br />
      <br />
      <h3>Create your account password</h3>
      <div>
        <mat-form-field appearance="outline" style="width: 300px; max-width:100%">
          <mat-label>Password</mat-label>
          <input
            matInput
            id="password"
            formControlName="password"
            placeholder="Enter password"
            type="password"
            autocomplete="off"
            required
          />
          <mat-error
            *ngIf="
              accountForm.get('password').touched &&
              accountForm.get('password').errors &&
              accountForm.get('password').errors.required"
          >
            Password is required
          </mat-error>
          <mat-error
            *ngIf="
              accountForm.get('password').touched &&
              accountForm.get('password').errors &&
              (accountForm.get('password').errors.minlength ||
                accountForm.get('password').errors.pattern)"
          >
            Password must meet all requirements.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" style="width: 300px; max-width:100%">
          <mat-label>Confirm Password</mat-label>
          <input
            matInput
            formControlName="confirmPassword"
            placeholder="Confirm password"
            id="confirmPassword"
            type="password"
            autocomplete="off"
            [errorStateMatcher]="passwordMatcherEmail"
            required
          />
          <mat-error
            *ngIf="
              accountForm.get('confirmPassword').touched &&
              accountForm.get('confirmPassword').errors &&
              accountForm.get('confirmPassword').errors.required
            "
          >
            Please re-enter your password
          </mat-error>
          <mat-error
            *ngIf="
              accountForm.get('confirmPassword').touched &&
              accountForm.errors?.password
            "
          >
            Passwords do not match
          </mat-error>
        </mat-form-field>
      </div>

      <small>
        Password must be 8 or more characters and at least one of each of the
        following from the list provided below:
        <ul>
          <li>Uppercase letter (A-Z)</li>
          <li>Lowercase letter (a-z)</li>
          <li>Digit (0-9)</li>
          <li>Special character (~`!@#$%^)</li>
        </ul>
      </small>
    </form>
    <div *ngIf="messageDisplay">
      <div style="color: red;" class="col-md-12">
        {{ messageDisplay
        }}<span *ngIf="messageDisplayShowLogout"
          >, Please <a href (click)="logout($event)">Logout</a> to complete
          registration using that account.</span
        >
      </div>
    </div>
    <div>
      <button type="button" mat-button
      (click)="returnToLogin()">Go Back</button>
      <button
        class="complete float-right"
        color="primary"
        [disabled]="!accountForm.valid && !tooManyAttempts"
        (click)="submitAccount()"
        type="button"
        mat-raised-button
      >
        Complete Account
      </button>
    </div>
  </mat-card>
</div>
